const actions = {
  CATALOGUE_TO_REQUEST: 'CATALOGUE_TO_REQUEST',
  DATASET_SETTINGS_TO_REQUEST: 'DATASET_SETTINGS_TO_REQUEST',
  DICTIONARIES_TO_REQUEST: 'DICTIONARIES_TO_REQUEST',
  DATASET_TO_REQUEST_ERROR: 'DATASET_TO_REQUEST_ERROR',
  FETCH_REQUEST_CATALOGUE: 'FETCH_REQUEST_CATALOGUE',
  FETCH_REQUEST_DATASETS: 'FETCH_REQUEST_DATASETS',
  FETCH_REQUEST_DICTIONARIES: 'FETCH_REQUEST_DICTIONARIES',
  FETCH_REQUEST_DATASET_SETTINGS: 'FETCH_REQUEST_DATASET_SETTINGS',
  SHOW_REQUEST_DATASETS: 'SHOW_REQUEST_DATASETS',
  TOGGLE_REQUEST_DATASET_SELECTED: 'TOGGLE_REQUEST_DATASET_SELECTED',
  UPDATE_REQUEST_DATASETS_FILTER: 'UPDATE_REQUEST_DATASETS_FILTER',
  UPDATE_REQUEST_DATASETS_FLAGS: 'UPDATE_REQUEST_DATASETS_FLAGS',
  UPDATE_REQUEST_DICTIONARIES: 'UPDATE_REQUEST_DICTIONARIES',
};

export default actions;
